var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"banner-section"},[_c('div',{staticClass:"container"},[_c('blockquote',[_c('h1',[_vm._v(_vm._s(_vm.data.title))]),_c('span',[_vm._v("- "+_vm._s(_vm.data.subtitle)+" -")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }